import React from 'react'
import MaterialSymbol from '../material-symbol'

const Publish = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="publish" {...props} />
))

Publish.displayName = 'Publish'

export default Publish
